import axios from "axios";
import { toastr } from "react-redux-toastr";
import { reset as resetForm, initialize } from "redux-form";
import { showTabs, selectTab } from "../common/tab/tabActions";
import util from '../consts'
const BASE_URL = util.API_URL;

var INITIAL_VALUES = {
}


export function getConfigs() {
    return submit({}, 'get')
}

export function salvar(values) {
    return submit(values, 'post')
}

function submit(values, method) {
    return dispatch => {
        axios[method](`${BASE_URL}/configuracao`, values)
            .then(resp => {
                if (method !== 'get') {
                    toastr.success('Sucesso', 'Operação Realizada com sucesso.')
                }
           
                
                dispatch(/*{
                    type: 'CONFIGURACAO_FETCHED',
                    payload: resp
                }*/
                setValuesForm(resp))
            }).catch(e => {
                if (e.response === undefined) {
                    toastr.error('Erro', e.message)
                } else {
                    e.response.data.errors.forEach(error => toastr.error('Erro', error))
                }
            })
    }
}


function setValuesForm(values) {
    return [
    initialize('configuracaoForm', values.data),
    {
        type: 'CONFIGURACAO_FETCHED',
        payload: values
    }
    ]
}

export function init() {
    return [
        showTabs('config'),
        selectTab('config'),
        getConfigs(),
        initialize('configuracaoForm', INITIAL_VALUES),
    ]
}






// WEBPACK FOOTER //
// ./src/configuracoes/configuracaoAction.js